import React from "react";
import S from "./MainVideoBlock.styled";
import { IWPLink } from "@/src/types";
import Button from "@/components/global-components/Button";
import Tag from "@/components/global-components/Tag";
import HandsIcon from "@/assets/hands.svg";

export interface MainVideoBlockProps {
  tag: string;
  title: string;
  text: string;
  link: IWPLink;
  videoUrl: string;
  mediaPosition: string;
  backgroundColor: string;
}

const MainVideoBlock: React.FC<MainVideoBlockProps> = ({
  tag,
  text,
  title,
  link,
  videoUrl,
  mediaPosition,
  backgroundColor,
}) => {
  return (
    <S.Inner $mediaPosition={mediaPosition} $bgColor={backgroundColor}>
      {videoUrl && (
        <>
          <S.VimeoHero dangerouslySetInnerHTML={{ __html: videoUrl }} />
          <S.IconWrapper $mediaPosition={mediaPosition}>
            <HandsIcon />
          </S.IconWrapper>
        </>
      )}
      <S.ContentWrapper>
        {tag && <Tag tag={tag} />}
        {title && <S.Title>{title}</S.Title>}
        {text && <S.Text>{text}</S.Text>}
        {link && (
          <S.BtnWrapper>
            <Button link={link} type="primary" arrow />
          </S.BtnWrapper>
        )}
      </S.ContentWrapper>
    </S.Inner>
  );
};

export default MainVideoBlock;
